import { IHeader, IProfile } from "./header";
import { IUserPreferences } from "./mongo";

export interface IUserProfile {
    fullName: string;
    firstName: string;
    lastName: string;
    email: string;
    zip: string;
    company: string;
    corpID: string;
    nmls: string;
    phone: string;
    userTheme: string;
    shortURL: string;
    state: string;
}

export interface IUser {
    id: string;
    header: IHeader;
    profile: IProfile;
    lrID: string;
    userPreferences: IUserPreferences;
    roles: ERole[];
}

/** this is based on legacy AspNetRoles */
export enum ERole {
    MBS_BACKEND = "mbsBackend",
    NO_LOCKOUT = "noLockout",
    SUPER_ADMINISTRATOR = "superAdministrator",
    CORP_ADMIN = "corpAdmin",
    /** Machine/service-account api keys only — doesn't exist in ASPNETROLES. */
    SYSTEM_SERVICE = "systemService",
}
